import $ from 'jquery'
import { onPageChange } from '../extensions/dom_ready'
// import 'focus-options-polyfill' // ensures focus({ preventScroll: true }) works in IE

export const handleDataFocus = (el) => {
  if (new URLSearchParams(window.location.search).has('iframe_preview')) return

  let fieldToFocus
  el = $(el)
  const selector = el.data('focus')
  if (selector === 'this') {
    fieldToFocus = el
  } else if (selector === 'first-field') {
    fieldToFocus = $('input:visible, textarea:visible', el[0])
      .filter(function () {
        return !$(this).closest('.js-object-picker-select').length
      })
      .first()

    // The button selector should not be focused when first element as there would be an active/focused element already based on the attribute value
    if (fieldToFocus.parents('.button-selectors').length) {
      fieldToFocus = null
    }
  } else if (selector === 'first-text-field') {
    // The first place to type: rich text editors count, toggles, buttons and other choices don't (nothing at all is
    // better than focusing a Save button). An object picker's own inputs are skipped, except the search box of one that
    // lists its options inline (a dropdown picker's search box is hidden until it opens).
    fieldToFocus = $(
      'input:visible, textarea:visible, [contenteditable="true"]:visible',
      el[0]
    )
      .filter(function () {
        const field = $(this)
        if (
          field.is(':checkbox, :radio, :submit, :button, :reset, :image, :file')
        )
          return false
        return (
          !field.closest('.js-object-picker-select').length ||
          field.is('[type="search"]')
        )
      })
      .first()
  } else if (selector === 'none') {
    // Do nothing!
  } else {
    fieldToFocus = $(selector)
  }

  // Don't do anything if the focus is already there, this seems to intermittently mess up system tests.
  if (fieldToFocus && !fieldToFocus.is(':focus')) {
    // fieldToFocus[0]? to ensure we perform focus on an HTMLElement
    return fieldToFocus[0]?.focus({ preventScroll: true })
  }
}

// A turbolinks-permanent element was carried over from the last page rather than rendered by
// this one — the help desk widget sits at the top of every admin body — so the field it would
// like focused is not this page's to give away.
onPageChange('focus form field', () =>
  $('[data-focus]')
    .not('[data-turbolinks-permanent] [data-focus]')
    .first()
    .each(function () {
      return handleDataFocus($(this))
    })
)
